//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return {
      serverList:Array,
      bubbleIndex:Number,
      pager: {
        page: '1',
        count: '1',
      },
      page: '1',
      count: '10',
    }
  },
  mounted() {
    this.getServer()
  },
  methods:{
    getServer(){
      let data = 'cmd=vps_list&page='+this.page+'&count='+this.count
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data.response == 200) {
          this.serverList = data.msg.content.map((item)=>{
            return{
              id:item.id,
              OsType_1:item.OsType_1,
              vps_name:item.vps_name,
              xianlu:item.NET_TYPE,
              ip:item.ip,
              EndTime:item.EndTime,
              Pstate:item.Pstate,
              state:this.VpsState(item.id) ? '' : '',
              cpu:item.CPU,
              ram:item.RAM,
              disk:item.SSD,
              net:item.NET_WIDTH,
            }
          })
          this.pager.count = data.msg.allpage
          this.pager.page = data.msg.curpage
        }else {
          this.$router.push('/login')
        }
      })
    },
    async VpsState(id) {
      let data = 'cmd=get_vps_state'+
        '&id='+ id
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data) {
          this.serverList.map((item, index) => {
            if(id == item.id){
              item.state = data
            }
          })
        }else {

        }
      })
    },
    pageNum(n, par) {
      if(par == 'up') {
        if(n > 1) {
          n = n - 1;
          this.page = n
          this.count = '10';
          this.getServer();
        }
      } else if(par == 'down') {
        if(n < this.pager.count) {
          n = parseInt(n) + 1;
          this.page = n
          this.count = '10';
          this.getServer();
        }
      }
    },
    Bubble(idx){
      if(this.bubbleIndex == idx){
        this.bubbleIndex = 10000
      }else{
        this.bubbleIndex = idx
      }
    },
    Mange(id) {
      this.$router.push('/user/server/'+ id)
    },
    Renew(id) {
      this.$router.push('/user/serverrenew/'+ id)
    },
    level(id,cpu,ram,ssd,net) {
      this.$router.push('/user/serverlevel/'+ id +'/'+ cpu +'/'+ ram +'/'+ ssd +'/'+ net)
    },
    ServerManage(id,state) {
      if(state != '未初始化'){
        this.$router.push('/user/server/'+ id)
      }else{
        let _this = this
        this.$vux.confirm.show({
          title: '确认',
          content: '您确定初始化吗?',
          onConfirm () {
            let data = 'cmd=vps_init'+
              '&id=' + id
            _this.$http.post('https://api.abeiyun.com/www/vps.php',data).then(({data})=>{
              if(data.response==200){
                _this.$vux.alert.show({
                  title: '提示信息',
                  content: data.msg,
                  onHide () {
                    _this.getServer()
                  }
                })
              }else{
                _this.$vux.alert.show({
                  title: '提示信息',
                  content: data.msg == 'smrz_fail' ? '您的帐户还没有实名认证 / 实名认证请用电脑认证' : data.msg,
                })
              }
            })
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/serverManage.vue